<template>
  <div class="detail-page">
    <div class="detail-header clearfix">
      <detail-header-nav
        :detailNavList="detailNavList"
        :pageTab="pageTab"
        @chooseTab="getTab"
      ></detail-header-nav>
      <div class="detail-header-btn">
        <Dropdown
          v-if="
            (pageTab === 'tab6' || pageTab === 'tab7') &&
              isHavePermission('ordersSeller:deleteInvoice')
          "
          style="margin-right: 10px"
        >
          <Button>
            批量删除
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem @click.native="deleteInvoice(1, '删除全部发票')"
              >删除全部发票</DropdownItem
            >
            <DropdownItem
              @click.native="
                deleteInvoice(
                  pageTab === 'tab7' ? 2 : 3,
                  '删除关联' +
                    (pageTab === 'tab7' ? '托运人' : '承运人') +
                    '发票'
                )
              "
            >
              删除关联{{ pageTab === "tab7" ? "托运人" : "承运人" }}发票
            </DropdownItem>
            <DropdownItem
              @click.native="
                deleteInvoice(
                  pageTab === 'tab7' ? 3 : 4,
                  '删除关联' +
                    (pageTab === 'tab7' ? '承运人' : '实际承运人') +
                    '发票'
                )
              "
            >
              删除关联{{ pageTab === "tab7" ? "承运人" : "实际承运人" }}发票
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown
          v-if="
            pageTab === 'tab3' && isHavePermission('ordersSeller:deleteReceive')
          "
          style="margin-right: 10px"
        >
          <Button>
            批量删除
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem @click.native="deleteReceive(1, '删除全部结算')"
              >删除全部结算</DropdownItem
            >
            <DropdownItem @click.native="deleteReceive(2, '删除托运人结算')"
              >删除托运人结算</DropdownItem
            >
            <DropdownItem @click.native="deleteReceive(3, '删除承运人结算')"
              >删除承运人结算</DropdownItem
            >
            <DropdownItem @click.native="deleteReceive(4, '删除实际承运人结算')"
              >删除实际承运人结算</DropdownItem
            >
          </DropdownMenu>
        </Dropdown>
        <Button
          type="primary"
          icon="md-add"
          v-if="
            isHavePermission('ordersSeller:updateOrCreateSupplyChain:updata')
          "
          @click.native="goEdit"
          >编辑订单
        </Button>
        <Dropdown
          v-if="
            isHavePermission('payments:createPaymentsSeller') ||
              isHavePermission('payments:createPaymentsSellerLv2') ||
              isHavePermission('payments:createPaymentsBuyer') ||
              isHavePermission('logistics:createLogistics') ||
              isHavePermission('receiving:createBuyerReceiveGoods:add') ||
              isHavePermission('receiving:createSellerLv2ReceiveGoods:add') ||
              isHavePermission('receiving:createSellerReceiveGoods:add') ||
              isHavePermission('invoice:createInvoiceSeller') ||
              isHavePermission('invoice:createInvoiceBuyer')
          "
          style="margin-left: 10px"
        >
          <Button>
            更多操作
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
              v-if="isHavePermission('logistics:createLogistics')"
              @click.native="showLogisticsModal"
            >
              新建物流信息
            </DropdownItem>
            <DropdownItem
              v-if="
                isHavePermission('receiving:createBuyerReceiveGoods:add') ||
                  isHavePermission(
                    'receiving:createSellerLv2ReceiveGoods:add'
                  ) ||
                  isHavePermission('receiving:createSellerReceiveGoods:add')
              "
              @click.native="showReceivingModal"
              >新建结算信息
            </DropdownItem>
            <DropdownItem
              v-if="
                isHavePermission('payments:createPaymentsBuyer') ||
                  isHavePermission('payments:createPaymentsBuyerOnline')
              "
              @click.native="showCreateCollection"
            >
              款项收入流程
            </DropdownItem>
            <DropdownItem
              v-if="
                isHavePermission('payments:createPaymentsSeller') ||
                  isHavePermission('payments:createPaymentsSellerOnline')
              "
              @click.native="showCreatePayment('Payment')"
              >费用支出流程
            </DropdownItem>
            <!-- <DropdownItem
              v-if="isHavePermission('payments:createPaymentsSellerLv2')"
              @click.native="showCreatePayment('SellerPayment')"
              >新建付款信息(实际供货)
            </DropdownItem> -->
            <DropdownItem
              v-if="isHavePermission('invoice:createInvoiceSeller')"
              @click.native="showCreateInvoice('Sales')"
              >开票申请流程
            </DropdownItem>
            <DropdownItem
              v-if="isHavePermission('invoice:createInvoiceBuyer')"
              @click.native="showCreateInvoice('Income')"
              >抵扣票申请流程
            </DropdownItem>
            <DropdownItem @click.native="showUpdateChainStatus()"
              >状态更新
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Button icon="md-refresh" @click="freshen" style="margin-left: 10px"
          >刷新
        </Button>
      </div>
    </div>
    <!-- STR 基本信息 -->
    <div v-show="pageTab === 'tab1'">
      <detail-title :title="conBoxTitle1.title"></detail-title>
      <detail-info :detailInfo="detailInfo" ref="detailInfo"></detail-info>
      <div v-show="buyerOrderLength > 0">
        <detail-title
          :title="conBoxTitle2.title"
          :showButton1="isHavePermission('ordersSeller:batchDownload')"
          :buttonInfo1="'批量导出附件'"
          @buttonOption1="batchDownload(1)"
        ></detail-title>
        <buyer-info
          :id="id"
          ref="buyerInfo"
          @buyerOrderLength="getBuyerOrderLength"
        ></buyer-info>
      </div>
      <div v-show="sellerOrderLength > 0">
        <detail-title
          :title="conBoxTitle3.title"
          :showButton="isHavePermission('ordersSeller:deleteAllOrder')"
          :showButton1="isHavePermission('ordersSeller:batchDownload')"
          :buttonInfo="'删除全部订单'"
          :buttonInfo1="'批量导出附件'"
          @buttonOption="commitDelete(3)"
          @buttonOption1="batchDownload(2)"
        ></detail-title>
        <seller-info
          :id="id"
          ref="sellerInfo"
          @sellerOrderLength="getSellerOrderLength"
        ></seller-info>
      </div>
      <div v-show="secSellerOrderLength > 0">
        <detail-title
          :title="conBoxTitle4.title"
          :showButton="isHavePermission('ordersSeller:deleteAllOrder')"
          :showButton1="isHavePermission('ordersSeller:batchDownload')"
          :buttonInfo="'删除全部订单'"
          :buttonInfo1="'批量导出附件'"
          @buttonOption="commitDelete(4)"
          @buttonOption1="batchDownload(3)"
        ></detail-title>
        <sec-seller-info
          :id="id"
          ref="secSellerInfo"
          @secSellerOrderLength="getsecSellerOrderLength"
        ></sec-seller-info>
      </div>
      <!-- <detail-title :title="conBoxTitle5.title"></detail-title>
      <detail-time-line :timeLineList="timeLineList"></detail-time-line>-->
    </div>
    <!-- END 基本信息 -->
    <!-- STR 物流信息 -->
    <div v-show="pageTab === 'tab2'">
      <all-order-logistics
        :id="id"
        :pageTab="pageTab"
        ref="logisticsList"
      ></all-order-logistics>
    </div>
    <!-- END 物流信息 -->
    <!-- STR 结算信息 -->
    <div v-show="pageTab === 'tab3'">
      <all-order-receiving
        :id="id"
        :pageTab="pageTab"
        ref="receivingList"
      ></all-order-receiving>
    </div>
    <!-- END 结算信息 -->
    <!-- STR 应收账款 -->
    <div v-show="pageTab === 'tab4'">
      <get-collection
        :id="id"
        :pageTab="pageTab"
        ref="getCollection"
      ></get-collection>
    </div>
    <!-- END 应收账款 -->
    <!-- STR 应付账款 -->
    <div v-show="pageTab === 'tab5'">
      <pay-collection
        :id="id"
        :pageTab="pageTab"
        ref="payColletion"
      ></pay-collection>
    </div>
    <!-- END 应付账款 -->
    <!-- STR 进项发票 -->
    <div v-show="pageTab === 'tab6'">
      <get-invoice :id="id" :pageTab="pageTab" ref="getInvoice"></get-invoice>
    </div>
    <!-- END 进项发票 -->
    <!-- STR 销项发票 -->
    <div v-show="pageTab === 'tab7'">
      <pay-invoice :id="id" :pageTab="pageTab" ref="payInvoice"></pay-invoice>
    </div>
    <!-- END 销项发票 -->

    <div v-show="pageTab === 'tab8'">
      <pay-list :id="id" :pageTab="pageTab" ref="payList"></pay-list>
    </div>

    <div v-show="pageTab === 'tab9'">
      <franchisee-list
        :id="id"
        :pageTab="pageTab"
        ref="franchiseeList"
      ></franchisee-list>
    </div>

    <vxe-modal
      v-model="receivingVisible"
      v-if="receivingVisible"
      title="新建结算信息"
      width="1300"
      position="center"
      @close="closeReceivingCreate"
      height="660"
      resize
    >
      <create-receiving-model
        ref="receivingModal"
        @createCommit="createCommit"
        v-bind:orderType="orderType"
        :orderId="id"
        v-bind:isIncludedTax="isIncludedTax"
      ></create-receiving-model>
    </vxe-modal>
    <vxe-modal
      v-model="logisticsVisible"
      title="新建物流信息"
      width="1300"
      @close="closeLogisticsModal"
      height="660"
      resize
      position="center"
    >
      <create-logistics-modal
        ref="logisticsModal"
        @afterSave="closeCreate"
        :orderId="id"
      ></create-logistics-modal>
    </vxe-modal>
    <!-- 款项收入流程 -->
    <vxe-modal
      v-model="isShowCreateCollection"
      width="1300"
      height="760"
      resize
      remember
      title="款项收入流程"
    >
      <create-collection
        :isShow="isShowCreateCollection"
        :cate="'Collection'"
        @close="isShowCreateCollection = false"
        @init="init"
        ref="createCollection"
      ></create-collection>
    </vxe-modal>
    <!-- 新建付款信息 -->
    <vxe-modal
      v-model="isShowCreatePayment"
      width="1300"
      height="760"
      resize
      remember
    >
      <div slot="title">
        费用支出流程{{ paymentCate === "SellerPayment" ? "(实际承运人)" : "" }}
      </div>
      <create-payment
        :chainId="id"
        :cate="paymentCate"
        :isShow="isShowCreatePayment"
        @close="isShowCreatePayment = false"
        @init="init"
        ref="createPayment"
      ></create-payment>
    </vxe-modal>

    <vxe-modal
      v-model="isShowCreateInvoice"
      width="1300"
      height="660"
      resize
      position="center"
    >
      <div slot="title">开票申请流程</div>
      <create-invoice
        :cate="'Sales'"
        :isShow="isShowCreateInvoice"
        @close="isShowCreateInvoice = false"
        @init="init"
        ref="createInvoice"
      ></create-invoice>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCreateInvoice2"
      width="1300"
      height="660"
      resize
      position="center"
    >
      <div slot="title">抵扣票申请流程</div>
      <create-invoice
        :cate="'Income'"
        :isShow="isShowCreateInvoice2"
        @close="isShowCreateInvoice2 = false"
        @init="init"
        ref="createInvoice2"
      ></create-invoice>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import DetailHeaderNav from "@/components/common/DetailHeaderNav"; // 详情页顶部导航组件
import DetailTitle from "@/components/common/DetailTitle"; // 标题组件
import DetailInfo from "@/components/order/all/DetailInfo"; // 基本信息
import BuyerInfo from "@/components/order/all/BuyerInfo"; // 托运人订单
import SellerInfo from "@/components/order/all/SellerInfo"; // 承运人订单
import SecSellerInfo from "@/components/order/all/SecSellerInfo"; // 实际承运人订单
// import DetailTimeLine from "@/components/common/DetailTimeLine"; // 时间轴组件
import AllOrderLogistics from "@/components/order/all/AllOrderLogistics"; // 物流信息
import AllOrderReceiving from "@/components/order/all/AllOrderReceiving"; // 结算信息
import GetCollection from "@/components/order/all/GetCollection"; // 应收账款
import PayCollection from "@/components/order/all/PayCollection"; // 应付账款
import GetInvoice from "@/components/order/all/GetInvoice"; // 进项发票
import PayInvoice from "@/components/order/all/PayInvoice"; // 销项发票
import PayList from "@/components/order/all/PayList"; // 付款明细
import FranchiseeList from "@/components/order/all/FranchiseeList"; // 付款明细
import CreateLogisticsModal from "@/views/logistics/CreateModal"; // 创建物流信息
import CreateReceivingModel from "@/views/receiving/CreateReceivingModel"; // 创建结算信息
import CreateCollection from "@/views/payment/CreateCollection.vue";
// import CreatePayment from "@/views/payment/CreatePayment.vue";
import CreatePayment from "@/components/modal/PayOrder.vue";
import CreateInvoice from "@/views/invoice/CreateInvoice.vue";
import getAuthOrization from "@/mixin/getAuthOrization";
import { showLoading, hideLoading, saveBlob, getBlob } from "@/utils/util";
import { apiPost } from "@/utils/api";

export default {
  name: "ChainDetail",
  mixins: [getAuthOrization],
  components: {
    DetailHeaderNav,
    DetailTitle,
    DetailInfo,
    BuyerInfo,
    SellerInfo,
    SecSellerInfo,
    // DetailTimeLine,
    AllOrderLogistics,
    AllOrderReceiving,
    GetCollection,
    PayCollection,
    GetInvoice,
    CreateReceivingModel,
    CreateLogisticsModal,
    PayInvoice,
    CreateCollection,
    CreatePayment,
    CreateInvoice,
    PayList,
    FranchiseeList
  },
  data() {
    return {
      id: parseInt(this.$route.params.id), // 主键ID
      invoiceType: null,
      aboutOrder: {
        orderId: null,
        orderNum: null
      },
      detailNavList: [
        // 详情页导航
        {
          title: "基础信息",
          tab: "tab1"
        },
        {
          title: "物流信息",
          tab: "tab2"
        },
        {
          title: "结算信息",
          tab: "tab3"
        },
        {
          title: "应收账款",
          tab: "tab4"
        },
        {
          title: "应付账款",
          tab: "tab5"
        },
        {
          title: "销项发票",
          tab: "tab7"
        },
        {
          title: "进项发票",
          tab: "tab6"
        },
        {
          title: "付款明细",
          tab: "tab8"
        }
      ],
      pageTab: "tab1", // 显示选项
      conBoxTitle1: {
        title: "基本信息"
      },
      conBoxTitle2: {
        title: "托运人订单"
      },
      conBoxTitle3: {
        title: "承运人订单"
      },
      conBoxTitle4: {
        title: "实际承运人订单"
      },
      conBoxTitle5: {
        title: "订单执行动态"
      },
      detailInfo: [], // 供应链详情
      logType: 0, // 0 供应链相关日志 1 托运人相关日志 2 承运人相关日志
      timeLineList: {}, // 订单执行动态
      orderType: 4,
      receivingVisible: false,
      logisticsVisible: false,

      isIncludedTax: "",

      isShowCreateCollection: false, //新建收款
      isShowCreatePayment: false, //新建付款
      isShowCreateInvoice: false, //新建发票
      isShowCreateInvoice2: false,
      paymentCate: "", //Collection payment SellerPayment
      invoiceCate: "", //Sales Income
      buyerOrderLength: 0,
      sellerOrderLength: 0,
      secSellerOrderLength: 0,
      isFromEdit: false
    };
  },
  watch: {
    $route(to, from) {
      if (to.name === "供应链详情") {
        this.pageTab = "tab1";
        this.id = parseInt(this.$route.params.id);
        this.init();
      }
    }
  },
  mounted() {
    this.pageTab = "tab1";
    this.init();
    this.initItem();
  },
  methods: {
    async batchDownload(type) {
      let that = this;
      showLoading();
      let res = getBlob("/api/tool/download/batchDownload", {
        chainId: this.id,
        type: type
      });
      hideLoading();
      await saveBlob(".zip", res.data);
    },
    deleteReceive(deleteRange, message) {
      this.$XModal.confirm("您确定要" + message + "吗？").then(type => {
        if (type === "confirm") {
          this.deleteReceiveGoodsByChainId(deleteRange);
        }
      });
    },
    async deleteReceiveGoodsByChainId(deleteRange) {
      let res = await $api.receiving.post("deleteReceiveGoodsByChainId", {
        chainId: this.id,
        deleteRange: deleteRange
      });
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.$refs.receivingList.getReceivingListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    deleteInvoice(deleteRange, message) {
      let pageTab = this.pageTab;
      this.$XModal.confirm("您确定要" + message + "吗？").then(type => {
        if (type === "confirm") {
          if (pageTab === "tab7") {
            this.deleteSellerInvoiceByChainId(deleteRange);
          } else if (pageTab === "tab6") {
            this.deleteBuyerInvoiceByChainId(deleteRange);
          }
        }
      });
    },
    async deleteBuyerInvoiceByChainId(deleteRange) {
      let res = await $api.invoice.post("deleteBuyerInvoiceByChainId", {
        chainId: this.id,
        deleteRange: deleteRange
      });
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.$refs.getInvoice.init();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    async deleteSellerInvoiceByChainId(deleteRange) {
      let res = await $api.invoice.post("deleteSellerInvoiceByChainId", {
        chainId: this.id,
        deleteRange: deleteRange
      });
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.$refs.payInvoice.init();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    commitDelete(deleteRange) {
      this.$XModal.confirm("您确定要删除全部订单吗？").then(type => {
        if (type === "confirm") {
          this.deleteAllOrder(deleteRange);
        }
      });
    },
    async deleteAllOrder(deleteRange) {
      let res = await $api.ordersSeller.post("deleteOrdersSellerByChainId", {
        chainId: this.id,
        deleteRange: deleteRange
      });
      if (res.data !== "" && res.data !== null) {
        this.$XModal.alert({
          message: res.data ? res.data : "接口异常",
          status: "error"
        });
      } else {
        this.$Message.success("删除成功");
        this.init();
      }
    },
    goEdit() {
      if (this.sellerOrderLength > 10 || this.secSellerOrderLength > 10) {
        this.$XModal.alert({
          message: "主订单关联订单过多，请通过对应子订单进行编辑",
          status: "error"
        });
      } else {
        this.$router.push(`/order/edit/${this.id}`);
      }
    },
    init() {
      this.getInfo();
      this.getTimeLine();
      this.$nextTick(() => {
        this.$refs.buyerInfo.getOrderList();
        this.$refs.sellerInfo.init();
        this.$refs.secSellerInfo.init();
      });
      this.$bus.$emit("allOrderDetailRenovate", true);
      // if (undefined != this.$refs.payColletion) {
      //   this.$refs.payColletion.init();
      // }
      // if (undefined != this.$refs.getCollection) {
      //   this.$refs.getCollection.init();
      // }
      // if (undefined != this.$refs.getInvoice) {
      //   this.$refs.getInvoice.init();
      // }
      // if (undefined != this.$refs.payInvoice) {
      //   this.$refs.payInvoice.init();
      // }
    },
    initItem() {
      let obj = {
        title: "加盟商往来",
        tab: "tab9"
      };
      if (this.isHavePermission("ordersAll:FranchiseeList")) {
        this.detailNavList.push(obj);
      }
    },
    freshen() {
      switch (this.pageTab) {
        case "tab1":
          this.init();
          break;
        case "tab2":
          //物流
          this.$refs.logisticsList.getLogisticsListData();
          break;
        case "tab3":
          //结算
          this.$refs.receivingList.getReceivingListData();
          break;
        case "tab4":
          this.$refs.getCollection.init();
          break;
        case "tab5":
          this.$refs.payColletion.init();
          break;
        case "tab6":
          this.invoiceType = 1;
          this.$refs.getInvoice.init();
          break;
        case "tab7":
          this.invoiceType = 2;
          this.$refs.payInvoice.init();
          break;
        case "tab8":
          this.$refs.payList.init();
          break;
        case "tab9":
          this.$refs.franchiseeList.init();
          break;
      }
    },
    getTab(val) {
      // 获取标签
      this.pageTab = val;
      // if (val === 'tab8') {
      //   this.$refs.payList.init();
      // }
    },
    closeReceivingCreate() {
      this.$refs.receivingModal.clearTableV();
      this.$refs.receivingModal.reCommit();
    },
    async getInfo() {
      // 获取订单信息
      this.isFromEidt = this.$route.query.isFromEidt;
      if(!this.isFromEidt) {
        console.log(123456);
        showLoading();
        this.isFromEidt = false;
      }
      this.detailInfo = [];
      let res = await apiPost("api/order/", "ordersSeller/querySupplyChain", {
        id: this.id
      });
      if (res.status === 1) {
        hideLoading();
        let arr = res.data;
        this.detailInfo.push(arr);
      } else {
        hideLoading();
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
      // $api.order.querySupplyChainModel
      //   .POST({
      //     data: {
      //       id: this.id,
      //     },
      //   })
      //   .then((res) => {
      //     if (res.status === 1) {
      //       hideLoading();
      //       let arr = res.data;
      //       this.detailInfo.push(arr);
      //     } else {
      //       hideLoading();
      //       this.$XModal.alert({
      //         message: res.message ? res.message : "接口异常",
      //         status: "error",
      //       });
      //     }
      //   });
    },
    showReceivingModal() {
      this.receivingVisible = true;
    },
    createCommit() {
      this.receivingVisible = false;
      this.$refs.receivingList.getReceivingListData();
    },
    showLogisticsModal() {
      this.logisticsVisible = true;
      this.$refs.logisticsModal.setExport(false);
    },
    closeLogisticsModal() {
      this.$refs.logisticsModal.close();
      this.logisticsVisible = false;
    },
    //显示新建收款
    showCreateCollection() {
      this.isShowCreateCollection = true;
      this.$refs.createCollection.initByChainId(this.id);
    },
    //显示新建付款
    showCreatePayment(paymentCate) {
      this.paymentCate = paymentCate;
      this.isShowCreatePayment = true;
      this.$refs.createPayment.initByChainId(this.id);
    },
    //显示新建发票
    showCreateInvoice(invoiceCate) {
      this.invoiceCate = invoiceCate;
      if (invoiceCate == "Sales") {
        this.isShowCreateInvoice = true;
        this.$refs.createInvoice.initByChainId(this.id);
      } else {
        this.isShowCreateInvoice2 = true;
        this.$refs.createInvoice2.initByChainId(this.id);
      }
    },
    showUpdateChainStatus() {
      this.$refs.detailInfo.showUpdateChainStatus();
    },
    closeCreate() {
      this.logisticsVisible = false;
      this.$refs.logisticsList.getLogisticsListData();
    },
    getTimeLine() {
      // 获取订单执行动态
      $api.order.queryOrderLogListModel
        .POST({
          data: {
            orderId: this.id,
            logType: this.logType //
          }
        })
        .then(res => {
          if (res.status === 1) {
            this.timeLineList = res.data;
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error"
            });
          }
        });
    },
    getBuyerOrderLength(len) {
      this.buyerOrderLength = len;
    },
    getSellerOrderLength(len) {
      this.sellerOrderLength = len;
    },
    getsecSellerOrderLength(len) {
      this.secSellerOrderLength = len;
    }
  }
};
</script>

<style>
.vxe-table--ignore-clear.size--small {
  width: calc(50% - 64px);
}

.vxe-table--ignore-clear.size--mini {
  width: calc(40% - 64px);
}
</style>
